import React from 'react'

const FormSkeleton = () => {
  return (
    <div className='w-full h-[630px] lg:h-[768px] border-t-[5px] border-[#009fde] rounded-2xl overflow-hidden'>
        <div className='h-[82px] bg-gray-300 p-4'>
            <div className='w-full h-full bg-gray-200 rounded-lg animate-pulse'>

            </div>
        </div>
        <div className="h-[110px] bg-gray-300 p-4">
            <div className='w-full h-full bg-gray-200 rounded-lg animate-pulse'>

            </div>
        </div>
        <div className='h-[572px] bg-gray-300'>
        <div className="h-[110px] bg-gray-300 p-4">
            <div className='w-full h-full bg-gray-200 rounded-lg animate-pulse'>

            </div>
        </div>
        <div className="h-[110px] bg-gray-300 p-4">
            <div className='w-full h-full bg-gray-200 rounded-lg animate-pulse'>

            </div>
        </div>
        <div className="h-[110px] bg-gray-300 p-4">
            <div className='w-full h-full bg-gray-200 rounded-lg animate-pulse'>

            </div>
        </div>
        <div className="h-[110px] bg-gray-300 p-4">
            <div className='w-full h-full bg-gray-200 rounded-lg animate-pulse'>

            </div>
        </div>
        <div className="h-[110px] bg-gray-300 p-4 hidden md:block">
            <div className='w-full h-full bg-gray-200 rounded-lg animate-pulse'>

            </div>
        </div>
        </div>
    </div>
  )
}

export default FormSkeleton